/* eslint-disable react/jsx-no-comment-textnodes */
import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { AlertInlineMain, HorizontalTabBar } from '@inmoment/the-kitchen';
import { expCardDataObject } from './expCardDataObject';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = [
  'IconButton Object Example',
  'ExpCard IconButton "types"',
  'NotesData Object Example',
  'Notes Object Example',
  'Comment Object Example',
  'Localization',
].map(convertArrayToTabBar);

export const ExperienceCardDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState(data1[4]);

  return (
    <div>
      <p className="kxi-text-600 kxi-text-normal">Experience Card Data Structures</p>
      <br />
      <br />
      <br />
      <div style={{ height: 46 }}>
        <HorizontalTabBar stretch color="orca" data={data1} onTabChange={({ tab }) => setTab(tab)} />
      </div>
      <br />
      {tab.title === data1[0].title && (
        <>
          <CodeBlock
            hasBorder
            code={`{
  icon: 'reply';
  type: 'tooltip';
  alwaysDisplay: true;
  title: 'Reply';
  dropdownData: [];
  onClick: '() => {}';
}`}
          />
          <br />
          <AlertInlineMain
            color="warning"
            title="Note!"
            subtitle="The Experience Card defaults to 4 icons, plus the kabob if more are passed. There is now a property called alwaysDisplay, that will always show the icon (even if more than 4) if there is space. They will be shown in the order placed (giving priority to alwaysDisplay.) Any buttons with the type `dropdown` will hide the dropdown data if they are after the 4th element in the array."
          />
        </>
      )}
      {tab.title === data1[1].title && (
        <>
          <CodeBlock hasBorder code="export type ExperienceCardIconButtonTypes = 'dropdown' | 'tooltip' | 'favorite' | 'notes';" />
          <br />
          <p className="kxi-text-large">
            <strong>Dropdown:</strong> Allows you to pass in data that will be shown inside a dropdown. <br />
            <strong>Tooltip:</strong> Displays a tooltip when hovered over. <br />
            <strong>Favorite:</strong> Displays the heart icon, and allows the use of the <code>isFavorite</code> top level property. <br />
            <strong>Comment:</strong> The only icon that has built in functionality - when this is passed in conjunction with the{' '}
            <code>notesData</code> object, clicking on this icon will show the option to add a new note. Whenever the notes are updated the
            onNotesChange function will fire.
          </p>
          <br />
          <br />
          <br />
          <AlertInlineMain
            color="warning"
            title="Note!"
            subtitle="The Experience Card defaults to 4 icons, plus the kabob if more are passed. There is now a property called alwaysDisplay, that will always show the icon (even if more than 4) if there is space. They will be shown in the order placed (giving priority to alwaysDisplay.) Any buttons with the type `dropdown` will hide the dropdown data if they are after the 4th element in the array."
          />
        </>
      )}

      {tab.title === data1[2].title && (
        <>
          <CodeBlock
            hasBorder
            code={`const notesData = {
  notes: /* [see note object tab] */,
  placeholder: 'Placeholder',
  onNoteChange: () => {},
}`}
          />
          <br />
          <br />
        </>
      )}
      <br />
      {tab.title === data1[0].title || tab.title === data1[1].title ? (
        <AlertInlineMain
          title="IconButton"
          subtitle="Any icon can be passed into the `iconButtons` array. It accepts an array of
            objects with 5 different properties."
          color="success"
        />
      ) : null}
      {tab.title === data1[3].title && (
        <>
          <CodeBlock
            hasBorder
            code={`{
  text: 'Note Here',
  meta: ['Jan 1 2020', 'John Wrote']
}`}
          />
          <br />
          <br />
          <br />
          <AlertInlineMain
            color="warning"
            title="Note!"
            subtitle="Note the array that is set up for Meta - it can either be a standard JS Date Object, a string, or the string 'self' - In the localization object there is a place to predefine the text. If you pass in 'self' - it will default to 'You Wrote.'"
          />
        </>
      )}
      {tab.title === data1[4].title && (
        <>
          <CodeBlock hasBorder>{expCardDataObject}</CodeBlock>
          <br />
          <br />
          <br />
          <AlertInlineMain
            color="error"
            title="Comment Data Object"
            subtitle="We have done our best to match the comment object provided by the database. There are a few differences in the objects - check out the differences tab for a complete reference."
          />
          <br />
          <AlertInlineMain
            color="success"
            title="Highlighted Id Function"
            subtitle="The Experience Card has a highlighted state that is activated when the `answerId` matches the `highlightedCommentId` that can be passed into the overall card - clicking on the 'More Moments Like This' function will trigger the `onMoreClick` callback allowing you to update the highlighted Id. It is up to the application to keep track of which id is currently highlighted."
          />
          <br />
          <AlertInlineMain
            color="warning"
            title="Media URLs"
            subtitle="Make sure to only pass in one URL for the three possible - leave the other two undefined."
          />
        </>
      )}
      {tab.title === data1[5].title && (
        <>
          <CodeBlock
            hasBorder
            code={`const notes = {
  add: 'Add',
  cancel: 'Cancel',
  notes: 'Notes',
  edit: 'Edit',
  locale: 'en-US',
  youWrote: 'You Wrote'
};

const sentiments = {
  positive: 'Positive',
  negative: 'Negative',
  neutral: 'Neutral',
};

const comments = {
  sentiment: 'Sentiment',
  sentimentScore: 'Sentiment Score',
  confidenceLevel: 'Confidence Level',
  confident: 'Confidence',
  moreMoments: 'More Moments Like This',
  andSentiments: 'and Sentiments' // for mobile view
  tags: 'Tags'
};

const tags = {
  add: 'Add',
  save: 'Save',
  addConfirm: 'Confirm',
  cancel: 'Cancel',
};

const experienceCardLocalization = {
  notes: notes,
  sentiments: sentiments,
  comments: comments,
  tags: tags,
};`}
          />
          <br />
          <br />
          <br />
        </>
      )}

      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
